var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrphixAgent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1E293B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9587 17.0502C15.5979 18.415 13.9418 19.0001 11.9904 19.0001C10.039 19.0001 8.38285 18.415 7.02201 17.0502C5.674 15.6723 5 13.9889 5 12.0001C5 10.0113 5.674 8.33441 7.02201 6.96953C8.38285 5.59165 10.039 5.00009 11.9904 5.00009C13.9418 5.00009 15.5979 5.59165 16.9587 6.96953C18.3196 8.33441 19 10.0113 19 12.0001C19 13.9889 18.3196 15.6723 16.9587 17.0502ZM8.88996 15.2173C9.72444 16.0492 10.7579 16.4652 11.9904 16.4652C13.2228 16.4652 14.2563 16.0492 15.0908 15.2173C15.9253 14.3724 16.3425 13.3 16.3425 12.0001C16.3425 10.7002 15.9253 9.6278 15.0908 8.78287C14.2563 7.93794 13.2228 7.51548 11.9904 7.51548C10.7579 7.51548 9.72444 7.93794 8.88996 8.78287C8.05548 9.6278 7.63824 10.7002 7.63824 12.0001C7.63824 13.3 8.05548 14.3724 8.88996 15.2173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrphixAgent);
export default __webpack_public_path__ + "static/media/orphix_agent.9de1ef87e619e3c5b056b8482a2210a7.svg";
export { ForwardRef as ReactComponent };